var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79102 0 0 1.79083 0 4V12C0 14.2092 1.79102 16 4 16H12C14.209 16 16 14.2092 16 12V4C16 1.79083 14.209 0 12 0H4Z",
    fill: "#5F6877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2C2.33579 2 2 2.33579 2 2.75V13.25C2 13.6642 2.33579 14 2.75 14H6.5V13.25H3.5V12.5H6.5V11.75H5V11H6.5V10.25H3.5V9.5H6.5V8.75H5V8H6.5V7.25H3.5V6.5H6.5V3.5H7.25V6.5H8V5H8.75V6.5H9.5V3.5H10.25V6.5H11V5H11.75V6.5H12.5V3.5H13.25V6.5H14V2.75C14 2.33579 13.6642 2 13.25 2H2.75Z",
    fill: "#9E9DAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric);
export default __webpack_public_path__ + "static/media/metric.58f9ae95cddbbce61ddce72b3776fa96.svg";
export { ForwardRef as ReactComponent };